import React from 'react';
import FlightRow from "~/Pages/RsvpRegistration/Travel/FlightRow";
import produce from "immer";
import TextTranslate from '../../../Components/TextTranslate/TextTranslate';

const Flight = ({onChange, values, errors, ...props}) => {

    const flightRowChanged = (value, type) => {
        onChange(produce(values, (draft) => {
            draft[type] = value;
        }));
    };

    const travelPoints = {
        inbound: "Arrival",
        outbound: "Departure",
    }

    return (
        <>
            <hr/>
            {Object.keys(travelPoints).map((key, idx) =>
                <div className="flight-tab row">
                    <div className="col-12">
                        <h3><TextTranslate name={`flight-${key}`} fallback={`${travelPoints[key]} Flight`} textOnly/></h3>
                        <p className="d-block"><TextTranslate name={`flight-${key}-note`} fallback="Please fill out your flight details." textOnly/></p>
                    </div>
                    <div className="col-12">
                        <FlightRow
                            errors={errors}
                            type={key}
                            values={values[key]}
                            onChange={(form) => flightRowChanged(form, key)} />
                    </div>
                </div>
            )}
        </>
    )
}

export default Flight;
